import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { push } from 'react-router-redux'
import axios from 'axios'

// Styles
import styles from './styles'

// Material UI
import { withStyles } from 'material-ui/styles'
import Typography from 'material-ui/Typography'
import Stepper, { Step, StepLabel, StepContent } from 'material-ui/Stepper'
import Button from 'material-ui/Button'
import Paper from 'material-ui/Paper'
import Input, { InputLabel } from 'material-ui/Input'
import { MenuItem } from 'material-ui/Menu'
import Table, {
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from 'material-ui/Table'
import Select from 'material-ui/Select'
import Radio, { RadioGroup } from 'material-ui/Radio'
import {
  FormLabel,
  FormControl,
  FormControlLabel,
  FormHelperText
} from 'material-ui/Form'
import * as algoliasearch from 'algoliasearch'

let id = 0
function createData(rating, userbase) {
  id += 1
  return { id, rating, userbase }
}

const data = [
  createData(7.0, 3008),
  createData(8.0, 1322),
  createData(8.5, 706),
  createData(9.0, 471),
  createData(9.5, 170),
  createData(10.0, 53)
]

var client = algoliasearch('5B2G72ZK2N', '1aaebeea6fc4b1dd6695ee42d9d823c1')
const index = client.initIndex('Candidates')

class Start extends Component {
  constructor(props) {
    super(props)

    this.state = {
      height: 'Average',
      body: 'Slim',
      race: 'White',
      showPopulation: false,
      popCount: 'Loading...',
      popLoaded: false,
      nbHits: ' ~',
      baseball: '',
      basketball: '',
      all_values: '',
      body_type: '',
      smoking_status: '',
      faith: '',
      education: '',
      occupation: '',
      drinking_status: '',
      marital_status: '',
      kid_info: '',
      salary_range: '',
      ethnicity: ''
    }
  }

  onNext() {
    this.props.changeRoute(
      `/console/search/saved_searches/filter/profile_facts/results?query=${
        this.state.all_values
      }&saved_search_id=${this.state.search_id}`
    )
  }

  handleChange = value => {
    /*
    let name = value;
    let all_values = this.state.all_values;
    all_values = all_values +" "+value;
    this.setState({
      [name]: value,
      all_values:  all_values
    }, () => {
      
    })*/
  }

  onShowPopulation = () => {}

  componentDidMount() {
    let urlParams = new URLSearchParams(window.location.search)
    let saved_search_id = urlParams.get('search_id').replace('%20', '')

    this.setState({
      search_id: saved_search_id
    })
  }

  handleChange = event => {
    let all_values = `${this.state.body_type} ${this.state.smoking_status} ${
      this.state.faith
    } ${this.state.education} ${this.state.occupation} ${
      this.state.drinking_status
    } ${this.state.marital_status} ${this.state.kid_info} ${
      this.state.salary_range
    } ${this.state.ethnicity}`
    let myComponent = this

    this.setState(
      {
        [event.target.name]: event.target.value,
        all_values: all_values
      },
      () => {
        // only query string
        index.search(
          {
            query: all_values
          },
          function searchDone(err, content) {
            if (err) throw err
            console.log(content)
            myComponent.setState({
              nbHits: content.nbHits
            })
          }
        )
      }
    )
  }

  render() {
    const { classes, theme, location } = this.props
    const { showPopulation } = this.state

    return (
      <div className={classes.root}>
        <br />
        <Typography type="body2" color="inherit" className={classes.flex}>
          Profile Facts Filter
        </Typography>
        <br />
        <Typography>Select the profile items to filter with:</Typography>
        <form autoComplete="off">
          <FormControl className={classes.lowest}>
            <InputLabel htmlFor="body_type">Body Type</InputLabel>
            <Select
              value={this.state.body_type}
              onChange={this.handleChange}
              input={<Input name="body_type" id="body_type" />}
            >
              <MenuItem value={'slender'}>Slender</MenuItem>
              <MenuItem value={'athletic and toned'}>Athletic & Toned</MenuItem>
              <MenuItem value={'average'}>Average</MenuItem>
              <MenuItem value={'few extra'}>Few Extra</MenuItem>
              <MenuItem value={'heavy'}>Heavy</MenuItem>
            </Select>
          </FormControl>
        </form>

        <form autoComplete="off">
          <FormControl className={classes.lowest}>
            <InputLabel htmlFor="smoking_status">Smoking Status</InputLabel>
            <Select
              value={this.state.smoking_status}
              onChange={this.handleChange}
              input={<Input name="smoking_status" id="smoking_status" />}
            >
              <MenuItem value={'wtl'}>WTL</MenuItem>
              <MenuItem value={'no way'}>No Way</MenuItem>
              <MenuItem value={'occassionally'}>Occassionally</MenuItem>
              <MenuItem value={'daily'}>Daily</MenuItem>
              <MenuItem value={'cigar aficionado'}>Cigar Aficionado</MenuItem>
              <MenuItem value={'yes, but trying to quit'}>
                Yes, but trying to quit
              </MenuItem>
              <MenuItem value={'often'}>Often</MenuItem>
            </Select>
          </FormControl>
        </form>

        <form autoComplete="off">
          <FormControl className={classes.lowest}>
            <InputLabel htmlFor="faith">Faith</InputLabel>
            <Select
              value={this.state.faith}
              onChange={this.handleChange}
              input={<Input name="faith" id="faith" />}
            >
              <MenuItem value={'wtl'}>WTL</MenuItem>
              <MenuItem value={'agnostic'}>Agnostic</MenuItem>
              <MenuItem value={'atheist'}>Atheist</MenuItem>
              <MenuItem value={'buddhist'}>Buddhist</MenuItem>
              <MenuItem value={'christian'}>Christian</MenuItem>
              <MenuItem value={'hindu'}>Hindu</MenuItem>
              <MenuItem value={'jewish'}>Jewish</MenuItem>
              <MenuItem value={'muslim'}>Muslim/Islam</MenuItem>
              <MenuItem value={'spiritual'}>
                Spiritual but not religious
              </MenuItem>
              <MenuItem value={'other'}>Other</MenuItem>
              <MenuItem value={'christian'}>Christian/Other</MenuItem>
              <MenuItem value={'new age'}>New Age</MenuItem>
            </Select>
          </FormControl>
        </form>
        <form autoComplete="off">
          <FormControl className={classes.lowest}>
            <InputLabel htmlFor="education">Education</InputLabel>
            <Select
              value={this.state.education}
              onChange={this.handleChange}
              input={<Input name="education" id="education" />}
            >
              <MenuItem value={'wtl'}>WTL</MenuItem>
              <MenuItem value={'high school'}>High School</MenuItem>
              <MenuItem value={'some college'}>Some College</MenuItem>
              <MenuItem value={'associates degree'}>Associates Degree</MenuItem>
              <MenuItem value={"bachelor's degree"}>Bachelor's Degree</MenuItem>
              <MenuItem value={'graduate degree'}>Graduate Degree</MenuItem>
              <MenuItem value={'phd'}>PhD/Post-Doctoral</MenuItem>
              <MenuItem value={'master'}>Master's Degree</MenuItem>
              <MenuItem value={'some university'}>Some University</MenuItem>
              <MenuItem value={'no degree'}>No Degree</MenuItem>
            </Select>
          </FormControl>
        </form>
        <form autoComplete="off">
          <FormControl className={classes.lowest}>
            <InputLabel htmlFor="occupation">Occupation</InputLabel>
            <Select
              value={this.state.occupation}
              onChange={this.handleChange}
              input={<Input name="occupation" id="occupation" />}
            >
              <MenuItem value={'wtl'}>WTL</MenuItem>
              <MenuItem value={'administrative'}>
                Administrative/Secretarial
              </MenuItem>
              <MenuItem value={'artistic/creative/performance'}>
                Artistic/Creative/Performance
              </MenuItem>
              <MenuItem value={'executive/management'}>
                Executive/Management
              </MenuItem>
              <MenuItem value={'financial/accounting/real estate'}>
                Financial/Accounting/Real Estate
              </MenuItem>
              <MenuItem value={'labor/construction'}>
                Labor/Construction
              </MenuItem>
              <MenuItem value={'legal'}>Legal</MenuItem>
              <MenuItem value={'medical/dental/veterniary/fitness'}>
                Medical/Dental/Veterniary/Fitness
              </MenuItem>
              <MenuItem value={'political/govt/civil service/military'}>
                Political/Govt/Civil Service/Military
              </MenuItem>
              <MenuItem value={'retail/food services'}>
                Retail/Food Services
              </MenuItem>
              <MenuItem value={'retired'}>Retired</MenuItem>
              <MenuItem value={'sales/marketing'}>Sales/Marketing</MenuItem>
              <MenuItem value={'self employed entreprenour'}>
                Self Employed Entrepreneur
              </MenuItem>
              <MenuItem value={'student'}>Student</MenuItem>
              <MenuItem value={'education/teacher/professor'}>
                Education/Teacher/Professor
              </MenuItem>
              <MenuItem value={'technical/science/computers/engineer'}>
                Technical/Science/Computers/Engineer
              </MenuItem>
              <MenuItem value={'travel/hospitality/transporation'}>
                Travel/Hospitality/Transportation
              </MenuItem>
              <MenuItem value={'other profession'}>Other Profession</MenuItem>
              <MenuItem value={'nonprofit/volunteer/activist'}>
                Nonprofit/Volunteer/Activist
              </MenuItem>
              <MenuItem value={'law enforcement/security/military'}>
                Law Enforcement/Security/Military
              </MenuItem>
              <MenuItem value={'fashion/model/beauty'}>
                Fashion/Model/Beauty
              </MenuItem>
              <MenuItem value={'architecture/interior design'}>
                Architecture/Interior Design
              </MenuItem>
              <MenuItem value={'unemployed'}>Unemployed</MenuItem>
              <MenuItem value={'lifestyle'}>Lifestyle</MenuItem>
              <MenuItem value={'professional'}>Professional</MenuItem>
            </Select>
          </FormControl>
        </form>
        <form autoComplete="off">
          <FormControl className={classes.lowest}>
            <InputLabel htmlFor="drinking_status">Drinking Status</InputLabel>
            <Select
              value={this.state.drinking_status}
              onChange={this.handleChange}
              input={<Input name="drinking_status" id="drinking_status" />}
            >
              <MenuItem value={'wtl'}>WTL</MenuItem>
              <MenuItem value={'never'}>Never</MenuItem>
              <MenuItem value={'social drinker'}>Social Drinker</MenuItem>
              <MenuItem value={'regularly'}>Regularly</MenuItem>
              <MenuItem value={'moderately'}>Moderately</MenuItem>
              <MenuItem value={'often'}>Often</MenuItem>
              <MenuItem value={'prefer not to say'}>Prefer not to say</MenuItem>
            </Select>
          </FormControl>
        </form>
        <form autoComplete="off">
          <FormControl className={classes.lowest}>
            <InputLabel htmlFor="marital_status">Marital Status</InputLabel>
            <Select
              value={this.state.marital_status}
              onChange={this.handleChange}
              input={<Input name="marital_status" id="marital_status" />}
            >
              <MenuItem value={'wtl'}>WTL</MenuItem>
              <MenuItem value={'never married'}>Never Married</MenuItem>
              <MenuItem value={'widow/widower'}>Widow/Widower</MenuItem>
              <MenuItem value={'currently separated'}>
                Currently Separated
              </MenuItem>
              <MenuItem value={'divorced'}>Divorced</MenuItem>
              <MenuItem value={'single'}>Single</MenuItem>
            </Select>
          </FormControl>
        </form>
        <form autoComplete="off">
          <FormControl className={classes.lowest}>
            <InputLabel htmlFor="kid_info">Kid Info</InputLabel>
            <Select
              value={this.state.kid_info}
              onChange={this.handleChange}
              input={<Input name="kid_info" id="kid_info" />}
            >
              <MenuItem value={'wtl'}>WTL</MenuItem>
              <MenuItem value={'none'}>None</MenuItem>
              <MenuItem value={'yes, away'}>Yes, away</MenuItem>
              <MenuItem value={'yes, sometimes home'}>
                Yes, sometimes home
              </MenuItem>
              <MenuItem value={'yes, at home full time'}>
                Yes, at home full time
              </MenuItem>
              <MenuItem value={'yes, 1 away'}>Yes, 1 away</MenuItem>
              <MenuItem value={'yes, 1 sometimes home'}>
                Yes, 1 sometimes home
              </MenuItem>
              <MenuItem value={'yes, 1 at home full time'}>
                Yes, 1 at home full time
              </MenuItem>
              <MenuItem value={'yes, 2 away'}>Yes, 2 away</MenuItem>
              <MenuItem value={'yes, 2 sometimes home'}>
                Yes, 2 sometimes home
              </MenuItem>
              <MenuItem value={'yes, 2 at home full time'}>
                Yes, 2 at home full time
              </MenuItem>
              <MenuItem value={'yes, 3 away'}>Yes, 3 away</MenuItem>
              <MenuItem value={'yes, 3 sometimes home'}>
                Yes, 3 sometimes home
              </MenuItem>
              <MenuItem value={'yes, 3 at home full time'}>
                Yes, 3 at home full time
              </MenuItem>
              <MenuItem value={'yes, 3+ away'}>Yes, 3+ away</MenuItem>
              <MenuItem value={'yes, 3+ sometimes home'}>
                Yes, 3+ sometimes home
              </MenuItem>
              <MenuItem value={'yes, 3+ at home full time'}>
                Yes, 3+ at home full time
              </MenuItem>
              <MenuItem value={'anything'}>Anything</MenuItem>
              <MenuItem value={'yes'}>Yes</MenuItem>
              <MenuItem value={'all my kids are over 18'}>
                All my kids are over 18
              </MenuItem>
            </Select>
          </FormControl>
        </form>
        <form autoComplete="off">
          <FormControl className={classes.lowest}>
            <InputLabel htmlFor="salary_range">Salary Range</InputLabel>
            <Select
              value={this.state.salary_range}
              onChange={this.handleChange}
              input={<Input name="salary_range" id="salary_range" />}
            >
              <MenuItem value={'wtl'}>WTL</MenuItem>
              <MenuItem value={'less than $25,000'}>Less than $25,000</MenuItem>
              <MenuItem value={'$25,001 to $35,000'}>
                $25,001 to $35,000
              </MenuItem>
              <MenuItem value={'$35,001 to $50,000'}>
                $35,001 to $50,000
              </MenuItem>
              <MenuItem value={'$50,001 to $75,000'}>
                $50,001 to $75,000
              </MenuItem>
              <MenuItem value={'$75,001 to $100,000'}>
                $75,001 to $100,000
              </MenuItem>
              <MenuItem value={'$100,001 to $150,000'}>
                $100,001 to $150,000
              </MenuItem>
              <MenuItem value={'$150,000+'}>$150,000+</MenuItem>
            </Select>
          </FormControl>
        </form>
        <form autoComplete="off">
          <FormControl className={classes.lowest}>
            <InputLabel htmlFor="ethnicity">Ethnicity</InputLabel>
            <Select
              value={this.state.ethnicity}
              onChange={this.handleChange}
              input={<Input name="ethnicity" id="ethnicity" />}
            >
              <MenuItem value={'caucasian'}>Caucasian</MenuItem>
              <MenuItem value={'asian'}>Asian</MenuItem>
              <MenuItem value={'black'}>Black</MenuItem>
              <MenuItem value={'mixed race'}>Mixed Race</MenuItem>
              <MenuItem value={'hispanic/latin'}>Hispanic/Latin</MenuItem>
              <MenuItem value={'indian'}>Indian</MenuItem>
              <MenuItem value={'middle eastern'}>Middle Eastern</MenuItem>
              <MenuItem value={'native american'}>Native American</MenuItem>
              <MenuItem value={'pacific islander'}>Pacific Islander</MenuItem>
              <MenuItem value={'white'}>White</MenuItem>
              <MenuItem value={'other'}>Other</MenuItem>
            </Select>
          </FormControl>
        </form>
        <br />
        <br />
        <Typography type="body2" color="inherit" className={classes.flex}>
          Population Count is {this.state.nbHits}
        </Typography>
        <div className={classes.buttonNext}>
          <Button
            raised
            onClick={() => this.onNext()}
            color="primary"
            align="center"
            className={classes.button}
          >
            Search Candidates
          </Button>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    customer_number: state.customer.number,
    project_id: state.prefix.project_id,
    oarlow: state.oar.low,
    oarhigh: state.oar.high,
    step: state.step.step
  }
}

function matchDispatchToProps(dispatch) {
  return {
    dispatch,
    changeRoute: url => dispatch(push(url))
  }
}

export default withRouter(
  withStyles(styles, { withTheme: true })(
    connect(mapStateToProps, matchDispatchToProps)(Start)
  )
)



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Search/scenes/SavedSearches/scenes/Filters/scenes/ProfileFacts/scenes/Start/index.js